import React, { useState, useMemo, useEffect, useContext, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Grid,
  Tooltip,
} from '@mui/material';
import Loading from 'assets/images/loading.png';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { poppins400, poppins500, fontsize10 } from 'theme/common.style';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from 'antd/es/avatar/avatar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Contact } from 'component/BuyerRegistration/BuyerRegistration.util';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { GET_BINDERID } from 'constant/app.config';
import { getApiCall } from 'api/apiService';
import Moxochat from 'component/Moxochat/Moxochat';
import PendingPrivatePopup from './PendingPrivatePopup';

const GreyPaper = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#C4C4C4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
      />
    </svg>
  );
};
const ColorPaper = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

export const Calldownarrow = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.44887 7.77981C3.40779 7.73979 3.23213 7.58867 3.08763 7.4479C2.17883 6.6226 0.691333 4.46966 0.237292 3.34281C0.164333 3.17168 0.00991667 2.73902 0 2.50785C0 2.28635 0.051 2.07519 0.154417 1.8737C0.298917 1.62252 0.526292 1.42103 0.79475 1.31062C0.981042 1.23955 1.5385 1.12914 1.54842 1.12914C2.15829 1.01873 3.14925 0.958008 4.24433 0.958008C5.28771 0.958008 6.23829 1.01873 6.85737 1.10913C6.86729 1.11948 7.56004 1.22989 7.79733 1.35064C8.23083 1.57215 8.5 2.00481 8.5 2.46783V2.50785C8.48938 2.8094 8.22021 3.44356 8.21029 3.44356C7.75554 4.50968 6.341 6.61294 5.40104 7.45825C5.40104 7.45825 5.1595 7.69632 5.00863 7.79983C4.79187 7.9613 4.52342 8.04134 4.25496 8.04134C3.95533 8.04134 3.67625 7.95095 3.44887 7.77981Z"
        fill="#666666"
      />
    </svg>
  );
};

const CircularProgressWithProfileVendor = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={props.value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {props.profileImage == '' || props.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                fontSize: '15px',
                backgroundColor: '#666666',
              }}
            >
              {props?.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props?.name}
              src={props.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default function SelectBuyersDialog({
  open,
  onClose,
  tableData,
  privateoffer,
  selectedBuyers,
  setSelectedBuyers,
  setBuyerHistory,
  getListInfo,
  handleRemoveBuyer,
  sentOfferBuyers,
  disabledBuyerIds,
  moxouserId,
  row,
  handleClose,
  handleClosee,
  profileDetails,
}) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [pendingOfferType, setPendingOfferType] = useState(null);

  const [loading, setLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);

  const [pendingBuyerId, setPendingBuyerId] = useState(null);
  const [showCounterAndPrivateDialog, setShowCounterAndPrivateDialog] =
    useState(false);
  const selectAllRef = useRef(null); // ⬅️ Add this once at the top

  // Handle message button click

  const [isHovered, setIsHovered] = useState(false);
  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 1500);
  };
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setDialogOpen(true);
  };

  const buyerPrivateOfferMap = useMemo(() => {
    const map = {};
    sentOfferBuyers?.forEach((entry) => {
      map[entry.buyerId] = entry.privateOfferId;
    });
    return map;
  }, [sentOfferBuyers]);

  const currentPrivateOfferId = privateoffer?.privateOfferId;

  const sentCurrentOfferBuyerIds = useMemo(() => {
    return (
      sentOfferBuyers
        ?.filter((buyer) => buyer.privateOfferId === currentPrivateOfferId)
        ?.map((buyer) => buyer.buyerId) || []
    );
  }, [sentOfferBuyers, currentPrivateOfferId]);

  const eligibleBuyers = useMemo(() => {
    return (
      tableData?.BuyerRegisterDetails?.filter((buyer) => {
        const buyerId = buyer?.buyerDetails?.user?.userId;
        const offerStatusCode = buyer?.buyerOfferDetails?.offerStatusCode;
        const offerStatusVendorCode =
          buyer?.buyerOfferDetails?.offerStatusVendorCode;
        const isSentCurrent = sentCurrentOfferBuyerIds?.includes(buyerId);
        const isDisabledStatus =
          offerStatusCode == 'BuyerAcc001' ||
          offerStatusCode == 'BuyerAccPrivate001' ||
          (offerStatusCode == 'VendorAcc001' &&
            offerStatusVendorCode == 'BuyerNotAcc001');

        return !isSentCurrent && !isDisabledStatus;
      }) || []
    );
  }, [tableData, sentCurrentOfferBuyerIds]);

  const isBuyerDisabled = (buyer) => {
    const buyerId = buyer?.buyerDetails?.user?.userId;
    const offerStatusCode = buyer?.buyerOfferDetails?.offerStatusCode;
    const offerStatusVendorCode =
      buyer?.buyerOfferDetails?.offerStatusVendorCode;

    return (
      sentCurrentOfferBuyerIds.includes(buyerId) ||
      offerStatusCode === 'BuyerAcc001' ||
      offerStatusCode === 'BuyerAccPrivate001' ||
      (offerStatusCode === 'VendorAcc001' &&
        offerStatusVendorCode === 'BuyerNotAcc001')
    );
  };

  const getPendingTypeSummaryForSelectAll = () => {
    const activeBuyers = tableData?.BuyerRegisterDetails?.filter(
      (buyer) => !isBuyerDisabled(buyer)
    );

    const types = activeBuyers
      ?.map((b) => b?.isExistPendingOffer)
      .filter(Boolean);

    const hasCounter = types.includes('Counter Pending');
    const hasPrivate = types.includes('Private Pending');

    if (hasCounter && hasPrivate) return 'Both';
    if (hasCounter) return 'Counter';
    if (hasPrivate) return 'Private';

    return null;
  };

  const handleSelectAllBuyers = () => {
    const eligibleIds = eligibleBuyers.map(
      (buyer) => buyer?.buyerDetails?.user?.userId
    );

    const allSelected = eligibleIds.every((id) => selectedBuyers.includes(id));

    if (!allSelected) {
      // 🟢 This is a "select all" action

      const hasCounterPending = eligibleBuyers.some(
        (buyer) =>
          buyer?.isExistPendingOffer === 'Counter Pending' ||
          buyer?.isExistPendingOffer === 'Private Pending'
      );

      if (hasCounterPending) {
        const summary = getPendingTypeSummaryForSelectAll();
        setPendingOfferType(summary);
        setPendingSelectAllAction(true);
        setShowCounterAndPrivateDialog(true);
        return;
      }

      // ✅ Select all
      const newSelected = [...selectedBuyers];
      eligibleIds.forEach((id) => {
        if (!newSelected.includes(id)) {
          newSelected.push(id);
        }
      });
      setSelectedBuyers(newSelected);
    } else {
      // 🟡 This is an "unselect all" action
      setSelectedBuyers((prev) =>
        prev.filter((id) => !eligibleIds.includes(id))
      );
    }
  };

  const [pendingSelectAllAction, setPendingSelectAllAction] = useState(false);

  const handleSelectBuyer = (buyerId, isSelectAll = false) => {
    const buyer = tableData?.BuyerRegisterDetails?.find(
      (b) => b?.buyerDetails?.user?.userId === buyerId
    );

    const isDisabled = disabledBuyerIds.includes(buyerId);

    const isAlreadySelected = selectedBuyers.includes(buyerId);

    const buyerPending = buyer?.isExistPendingOffer;

    const isPending =
      buyerPending === 'Counter Pending' || buyerPending === 'Private Pending';

    if (!isSelectAll && !isDisabled && !isAlreadySelected && isPending) {
      setPendingBuyerId(buyerId);
      setPendingOfferType(buyerPending);
      setPendingSelectAllAction(false);
      setShowCounterAndPrivateDialog(true);
      return;
    }
    setSelectedBuyers((prev) => {
      if (isAlreadySelected) {
        return prev.filter((id) => id !== buyerId);
      } else {
        return [...prev, buyerId];
      }
    });
  };

  useEffect(() => {}, [selectedBuyers, disabledBuyerIds]); // Run when these states change

  const handleSendPrivateOfferss = () => {
    setLoading(true);

    const buyerIds = selectedBuyers.map((buyerId) => buyerId);
    const propertyId = tableData?.PropertyDetails?.property?.propertyId;
    const offerPrice = privateoffer?.offerPrice;

    if (!propertyId || buyerIds.length == 0 || !offerPrice) {
      setLoading(false);
      return;
    }

    const sentBuyers = tableData?.BuyerRegisterDetails?.filter((buyer) =>
      buyerIds.includes(buyer?.buyerDetails?.user?.userId)
    ).map((buyer) => ({
      ...buyer,
      offerPrice,
    }));

    setBuyerHistory((prev) => {
      const existingIds = prev.map((b) => b?.buyerDetails?.user?.userId);
      const uniqueNewBuyers = sentBuyers.filter(
        (b) => !existingIds.includes(b?.buyerDetails?.user?.userId)
      );
      const updatedHistory = [...prev, ...uniqueNewBuyers];

      const key = `buyerHistory_${propertyId}`;
      localStorage.setItem(key, JSON.stringify(updatedHistory));

      return updatedHistory;
    });

    setSelectedBuyers([]);
    onClose();
    setLoading(false);
  };

  // const handleSelectBuyer = (buyerId) => {
  //   setSelectedBuyers((prevSelected) => {
  //     if (prevSelected.includes(buyerId)) {
  //       return prevSelected.filter((id) => id !== buyerId);
  //     } else {
  //       return [...prevSelected, buyerId];
  //     }
  //   });
  // };

  // const eligibleBuyers = tableData?.BuyerRegisterDetails?.filter(
  //   (buyer) =>
  //     !sentOfferBuyers?.some(
  //       (sent) => sent?.buyerId === buyer?.buyerDetails?.user?.userId
  //     )
  // ) || [];

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { realTimeLog, ischatopen, setIschatopen } = useContext(datacontext);

  // ✅ LocalStorage and IDs setup
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const agentId = userDetail?.userId;
  const userType = userDetail?.primaryUserType;
  const propertyId = tableData?.PropertyDetails?.property?.propertyId; // ← use actual dynamic value

  // ✅ Chat modal handler
  const onShowChatt = (binderId) => {
    setIschatopen(binderId); // Set current binderId
    setModalIsOpen(true); // Open chat modal
  };

  // ✅ Called when only userId is known — fetch binderId via API
  const directcomm = (userId) => {
    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChatt(resp?.data?.binderId);
      });
    }
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  const getPendingOfferAmount = (buyerId) => {
    const buyer = tableData?.BuyerRegisterDetails?.find(
      (b) => b?.buyerDetails?.user?.userId === buyerId
    );

    if (buyer?.buyerOfferDetails?.offerPriceVendor) {
      return buyer.buyerOfferDetails.offerPriceVendor;
    }

    return null;
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <Grid container height={'100%'}>
          <Grid
            container
            item
            xs={12}
            sx={{ padding: matchessm ? '20px' : '30px' }}
          >
            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'12px 0px 15px 0'}
            >
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: matchessm ? '16px' : '24px',
                  paddingLeft: '12px',
                  display: 'block',
                }}
              >
                Select Buyers
              </Typography>
            </Grid>

            <Grid item xs={12} marginTop={0}>
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                  paddingLeft: '12px',
                  display: 'block',
                }}
              >
                Choose which buyers should receive the Private Offer. You can
                select one or multiple recipients.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <DialogContent>
          {/* Buyers Table */}
          <TableContainer component={Paper} sx={{ maxHeight: 370 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ borderBottom: '1px solid #ddd' }}>
                  <TableCell>
                    <input
                      type="checkbox"
                      inputRef={selectAllRef}
                      checked={
                        eligibleBuyers.length > 0 &&
                        eligibleBuyers.every((buyer) =>
                          selectedBuyers.includes(
                            buyer?.buyerDetails?.user?.userId
                          )
                        )
                      }
                      onChange={handleSelectAllBuyers}
                      disabled={eligibleBuyers?.length === 0}
                      style={{
                        accentColor: '#A55FFB',
                        cursor:
                          eligibleBuyers.length === 0
                            ? 'not-allowed'
                            : 'pointer',
                        width: '16px',
                        height: '16px',
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <Typography
                      sx={{
                        fontSize: '10px',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        color: '#112347',
                        textAlign: 'left',
                        padding: '8px',
                        marginLeft: 8,
                      }}
                    >
                      Name
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: '10px',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      color: '#112347',
                      textAlign: 'center',
                      padding: '8px',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '10px',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        color: '#112347',
                        textAlign: 'left',
                        padding: '8px',
                        marginLeft: -5,
                      }}
                    >
                      Contact
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: '10px',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      color: '#112347',
                      textAlign: 'center',
                      padding: '8px',
                    }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: '10px',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      color: '#112347',
                      textAlign: 'center',
                      padding: '8px',
                    }}
                  >
                    Offers
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: '10px',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      color: '#112347',
                      textAlign: 'center',
                      padding: '8px',
                    }}
                  >
                    Number of Offers
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {tableData?.BuyerRegisterDetails?.length > 0 ? (
                  tableData?.BuyerRegisterDetails.map((buyer, index) => {
                    const buyerId = buyer?.buyerDetails?.user?.userId;
                    const offerStatusCode =
                      buyer?.buyerOfferDetails?.offerStatusCode;
                    const offerStatusVendorCode =
                      buyer?.buyerOfferDetails?.offerStatusVendorCode;

                    const isSent = sentOfferBuyers?.some(
                      (b) => b?.buyerId == buyerId
                    );
                    const isDisabled =
                      isSent || disabledBuyerIds.includes(buyerId);

                    return (
                      <TableRow
                        key={buyerId}
                        sx={{
                          borderBottom: '1px solid #ddd',
                          minHeight: '50px',
                          opacity:
                            sentCurrentOfferBuyerIds.includes(buyerId) ||
                            offerStatusCode == 'BuyerAcc001' ||
                            offerStatusCode == 'BuyerAccPrivate001' ||
                            (offerStatusCode == 'VendorAcc001' &&
                              offerStatusVendorCode == 'BuyerNotAcc001')
                              ? 0.5
                              : 1,
                          filter:
                            sentCurrentOfferBuyerIds.includes(buyerId) ||
                            offerStatusCode == 'BuyerAcc001' ||
                            offerStatusCode == 'BuyerAccPrivate001' ||
                            (offerStatusCode == 'VendorAcc001' &&
                              offerStatusVendorCode == 'BuyerNotAcc001')
                              ? 'blur(0.5px)'
                              : 'none',
                        }}
                      >
                        <TableCell
                          sx={{
                            width: '50px',
                            textAlign: 'center',
                            padding: '8px',
                            cursor:
                              sentCurrentOfferBuyerIds.includes(buyerId) ||
                              offerStatusCode == 'BuyerAcc001' ||
                              offerStatusCode == 'BuyerAccPrivate001' ||
                              (offerStatusCode == 'VendorAcc001' &&
                                offerStatusVendorCode == 'BuyerNotAcc001')
                                ? 'not-allowed'
                                : 'pointer',
                          }}
                          onClick={() => {
                            if (
                              !sentCurrentOfferBuyerIds.includes(buyerId) &&
                              offerStatusCode != 'BuyerAcc001' &&
                              offerStatusCode != 'BuyerAccPrivate001' &&
                              !(
                                offerStatusCode == 'VendorAcc001' &&
                                offerStatusVendorCode == 'BuyerNotAcc001'
                              )
                            ) {
                              handleSelectBuyer(buyerId);
                            }
                          }}
                        >
                          <Tooltip
                            title={
                              sentCurrentOfferBuyerIds.includes(buyerId)
                                ? 'Offer already sent to this buyer'
                                : offerStatusCode == 'BuyerAcc001' ||
                                  offerStatusCode == 'BuyerAccPrivate001' ||
                                  (offerStatusCode == 'VendorAcc001' &&
                                    offerStatusVendorCode == 'BuyerNotAcc001')
                                ? 'Offer accepted by the buyer'
                                : ''
                            }
                            PopperProps={{
                              disablePortal: false,
                              sx: {
                                zIndex: 1500,
                              },
                            }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontFamily: 'Poppins',
                                  fontSize: '12px',
                                  fontWeight: 400,
                                },
                              },
                            }}
                          >
                            <span>
                              <input
                                type="checkbox"
                                checked={selectedBuyers?.includes(buyerId)}
                                disabled={
                                  sentCurrentOfferBuyerIds.includes(buyerId) ||
                                  offerStatusCode == 'BuyerAcc001' ||
                                  offerStatusCode == 'BuyerAccPrivate001' ||
                                  (offerStatusCode == 'VendorAcc001' &&
                                    offerStatusVendorCode == 'BuyerNotAcc001')
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (
                                    !sentCurrentOfferBuyerIds.includes(
                                      buyerId
                                    ) &&
                                    offerStatusCode != 'BuyerAcc001' &&
                                    offerStatusCode != 'BuyerAccPrivate001' &&
                                    !(
                                      offerStatusCode == 'VendorAcc001' &&
                                      offerStatusVendorCode == 'BuyerNotAcc001'
                                    )
                                  ) {
                                    handleSelectBuyer(buyerId);
                                  }
                                }}
                                style={{
                                  accentColor: '#A55FFB',
                                  cursor:
                                    sentCurrentOfferBuyerIds.includes(
                                      buyerId
                                    ) ||
                                    offerStatusCode == 'BuyerAcc001' ||
                                    offerStatusCode == 'BuyerAccPrivate001' ||
                                    (offerStatusCode == 'VendorAcc001' &&
                                      offerStatusVendorCode == 'BuyerNotAcc001')
                                      ? 'not-allowed'
                                      : 'pointer',
                                  width: '16px',
                                  height: '16px',
                                }}
                              />
                            </span>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          sx={{
                            fontFamily: 'Poppins',
                            textAlign: 'left',
                            padding: '22px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <CircularProgressWithProfileVendor
                            value={buyer?.buyerDetails?.profileActivity}
                            name={
                              buyer?.buyerDetails?.user?.userName
                                .charAt(0)
                                ?.toUpperCase() +
                              buyer?.buyerDetails?.user?.userSurName
                                .charAt(0)
                                ?.toUpperCase()
                            }
                            profileImage={
                              buyer?.buyerDetails?.user?.userProfile
                            }
                          />
                          <Typography
                            sx={{ fontFamily: 'Poppins', fontWeight: 500 }}
                          >
                            {buyer?.buyerDetails?.user?.userName +
                              ' ' +
                              buyer?.buyerDetails?.user?.userSurName}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ textAlign: 'center', padding: '8px' }}>
                          <Contact
                            row={buyer?.buyerDetails}
                            directcomm={directcomm}
                          />
                        </TableCell>

                        <TableCell sx={{ textAlign: 'center', padding: '8px' }}>
                          {buyer?.buyerDetails?.is66Signed == 0 ? (
                            <GreyPaper />
                          ) : (
                            <ColorPaper />
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            fontSize: '14px',
                            fontWeight: '400',
                            fontFamily: 'Poppins',
                            color: '#112347',
                            textAlign: 'center',
                            padding: '8px',
                          }}
                        >
                          {buyer?.buyerOfferDetails?.offerPrice
                            ? buyer.buyerOfferDetails.offerPrice
                            : '-'}

                          {buyer?.buyerOfferDetails?.offerPrice && (
                            <Typography
                              sx={{
                                ...poppins500,
                                ...fontsize10,
                                display: 'flex',
                                flexDirection: 'column',
                                background:
                                  buyer?.buyerOfferDetails?.isWinner == 1
                                    ? 'rgba(108, 42, 210, 1)'
                                    : buyer?.buyerOfferDetails
                                        ?.logIsConditional == 1
                                    ? 'rgba(237, 11, 11, 0.6)'
                                    : buyer?.buyerOfferDetails
                                        ?.logIsConditional == 0
                                    ? 'rgba(16, 211, 94, 1)'
                                    : '-',
                                borderRadius: '5px',
                                color: 'white',
                                padding: '4px 8px',
                                height: '22px',
                              }}
                            >
                              {buyer?.buyerOfferDetails?.isWinner == 1
                                ? 'Winner'
                                : buyer?.buyerOfferDetails?.logIsConditional ==
                                  1
                                ? 'Conditional'
                                : 'Unconditional'}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            fontSize: '14px',
                            fontWeight: '400',
                            fontFamily: 'Poppins',
                            color: '#112347',
                            textAlign: 'center',
                            padding: '8px',
                          }}
                        >
                          {buyer?.buyerDetails?.noOfOffers
                            ? buyer?.buyerDetails?.noOfOffers
                            : '-'}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: '400',
                          fontFamily: 'Poppins',
                          color: '#666666',
                        }}
                      >
                        No buyers available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <Grid
          container
          item
          xs={12}
          sx={{ padding: matchessm ? '20px' : '30px' }}
        >
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'0px 0px 15px 0'}
          >
            {selectedBuyers.length > 0 && (
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  color: '#666666',
                }}
              >
                ({selectedBuyers.length}){' '}
                {selectedBuyers.length === 1
                  ? 'Buyer selected'
                  : 'Buyers selected'}
              </Typography>
            )}
          </Grid>
        </Grid>

        <DialogActions sx={{ marginBottom: '24px' }}>
          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 2,
              marginRight: 3,
            }}
          >
            <Grid item>
              <Button
                variant="outlined"
                sx={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  // Clear the selected buyers
                  setSelectedBuyers([]);

                  // Optionally, reset any other states, such as loading or disabledBuyerIds
                  setLoading(false);

                  // Close the dialog or trigger the onClose function
                  onClose();
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                sx={{
                  padding: matchessm ? '6px 30px' : '10px 50px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'Poppins',
                  backgroundColor: '#4CA4D6',
                  textTransform: 'none',
                  borderRadius: '5px',
                  '&:hover': {
                    backgroundColor: '#4CA4D6',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#4CA4D6',
                    color: '#fff',
                    opacity: 0.7,
                    cursor: 'not-allowed', // Ensure the cursor is explicitly defined here
                    pointerEvents: 'auto',
                  },
                }}
                onClick={handleSendPrivateOfferss}
                disabled={loading || selectedBuyers.length === 0}
              >
                Continue
              </Button>
              {loading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </DialogActions>
        {modalIsOpen && ischatopen != '' && (
          <Moxochat
            open={modalIsOpen}
            binderId={ischatopen} // ✅ Make sure this is set properly
            onClose={() => setModalIsOpen(false)}
          />
        )}
      </Dialog>
      {/* <CounterOfferalreadyexists
        profileDetails={profileDetails}
        open={showCounterAndPrivateDialog}
        onClose={() => {
          setShowCounterAndPrivateDialog(false);
          setPendingBuyerId(null);
          setPendingSelectAllAction(false);
        }}
        onContinue={() => {
          if (pendingSelectAllAction) {
            // ✅ Select All was clicked
            const eligibleIds = eligibleBuyers.map(
              (buyer) => buyer?.buyerDetails?.user?.userId
            );
            setSelectedBuyers(eligibleIds);
          } else if (pendingBuyerId) {
            // ✅ Individual checkbox was clicked
            setSelectedBuyers((prev) =>
              prev.includes(pendingBuyerId) ? prev : [...prev, pendingBuyerId]
            );
          }

          setShowCounterAndPrivateDialog(false);
          setPendingSelectAllAction(false);
          setPendingBuyerId(null);
        }}
        onCancel={() => {
          setShowCounterAndPrivateDialog(false);

          if (!pendingSelectAllAction && pendingBuyerId) {
            // ✅ Cancel for individual checkbox
            setSelectedBuyers((prev) =>
              prev.filter((id) => id !== pendingBuyerId)
            );
          }

          if (pendingSelectAllAction) {
            // ✅ Cancel for Select All — ensure no buyers added
            const eligibleIds = eligibleBuyers.map(
              (buyer) => buyer?.buyerDetails?.user?.userId
            );
            setSelectedBuyers((prev) =>
              prev.filter((id) => !eligibleIds.includes(id))
            );
          }

          setPendingSelectAllAction(false);
          setPendingBuyerId(null);
        }}
        pendingOfferType={pendingOfferType}
        fromTableHead={pendingSelectAllAction}
      /> */}

      <PendingPrivatePopup
        profileDetails={profileDetails}
        open={showCounterAndPrivateDialog}
        onClose={() => {
          setShowCounterAndPrivateDialog(false);
          setPendingBuyerId(null);
          setPendingSelectAllAction(false);
        }}
        onContinue={() => {
          if (pendingSelectAllAction) {
            const eligibleIds = eligibleBuyers.map(
              (buyer) => buyer?.buyerDetails?.user?.userId
            );
            setSelectedBuyers(eligibleIds);
          } else if (pendingBuyerId) {
            setSelectedBuyers((prev) =>
              prev.includes(pendingBuyerId) ? prev : [...prev, pendingBuyerId]
            );
          }

          setShowCounterAndPrivateDialog(false);
          setPendingSelectAllAction(false);
          setPendingBuyerId(null);
        }}
        onCancel={() => {
          setShowCounterAndPrivateDialog(false);

          if (!pendingSelectAllAction && pendingBuyerId) {
            setSelectedBuyers((prev) =>
              prev.filter((id) => id !== pendingBuyerId)
            );
          }

          if (pendingSelectAllAction) {
            const eligibleIds = eligibleBuyers.map(
              (buyer) => buyer?.buyerDetails?.user?.userId
            );
            setSelectedBuyers((prev) =>
              prev.filter((id) => !eligibleIds.includes(id))
            );
          }

          setPendingSelectAllAction(false);
          setPendingBuyerId(null);
        }}
        pendingOfferType={pendingOfferType}
        fromTableHead={pendingSelectAllAction}
        address={tableData?.PropertyDetails?.propertyAddress?.streetName}
        manageOfferData={{
          propertyAddress:
            tableData?.PropertyDetails?.propertyAddress?.streetName,
        }}
        tableData={tableData}
        pendingUserId={pendingBuyerId}
        currentPrivateOfferPrice={
          privateoffer?.offerPrice
            ? typeof privateoffer.offerPrice === 'string'
              ? parseFloat(privateoffer.offerPrice.replace(/[$,]/g, ''))
              : privateoffer.offerPrice
            : null
        }
        vendorAcceptedAmount={
          tableData?.PropertyDetails?.vendorStatus
            ?.unFormattedVendorSurveyPrice || null
        }
      />
    </>
  );
}
